export const environment = {
    production: false,
    //databaseID: 3, // comment-tracker
    databaseID: 2, // comment-tracker-stage
    api: 'https://api.comment-tracker.esassoc.com/api-stage/',
    //projectID: 12, // nisqually
    //projectID: 14, // airport
    projectID: 21, // clde
    theme: "clde",
    langs: ['en', 'zh', 'sp', 'va'], // ['en', 'fr', 'ceb', 'zh', 'fil', 'hmn', 'ja', 'kh', 'ko', 'mo', 'sp', 'va']
    //serverUrl: "http://comment-tracker.esassoc.com/demo/nisqually"
    //serverUrl: "http://comment-tracker.esassoc.com/demo/airport"
    serverUrl: "http://comment-tracker.esassoc.com/stage/clde"
  };
  


// WEBPACK FOOTER //
// ./src/environments/environment.ts